import { useMemo, useState } from "react";
import { GeoJSON, Marker, Polyline, Tooltip } from "react-leaflet";
import { divIcon, icon } from "leaflet";

import { Box, Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { renderToStaticMarkup } from "react-dom/server";

import Icon from "Components/Icon";
import useMarginPark from "Hooks/useMarginPark";

const ICON_SIZE = 22;

export default function MarginPark() {
  const dispatch = useAppDispatch();
  const { visible } = useAppSelector((state) => state.marginPark);

  const { data } = useMarginPark();

  const cameraMarkers = useMemo(() => {
    return data?.map((item: any) => {
      if (!item.Park) return;
      const marginPark = JSON.parse(`{${item.Park}}`);

      const parkIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${21 + (marginPark.Number + 1) / 12}px`,
            height: `${21 + (marginPark.Number + 1) / 12}px`,
            backgroundColor: "#fffd",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#62b362cc",
            display: "grid",
            placeItems: "center",
            color: "#666",
          }}
        >
          <Icon icon="local_parking" sx={{ color: "red", fontSize: `${16 + (marginPark.Number + 1) / 8}px` }} />
        </Box>
      );

      const parkIcon = divIcon({
        html: parkIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
        className: item.Status === 1 ? "green-color" : "red-color",
      });

      //   const tooltipContent = !isActive && (
      //     <Tooltip direction="top" offset={[0, -20]}>
      //       <Card sx={{ py: 2, px: 3 }}>
      //         <Stack alignItems="flex-end">
      //           <Typography>نام سامانه : {camera.DeviceName}</Typography>
      //           <Typography> تعداد : {camera.TTO}</Typography>
      //           <Typography>نوع سامانه : {camera.MethodName}</Typography>
      //           <Typography>کد سامانه : {camera?.DeviceCode}</Typography>
      //           <Typography>کد پلیس : {camera.PoliceCode} </Typography>
      //           <Typography>نام شرکت : {camera.CompanyName}</Typography>
      //         </Stack>
      //       </Card>
      //     </Tooltip>
      //   );

      return (
        <>
          <Marker position={[Number(marginPark.Lat), Number(marginPark.Long)]} icon={parkIcon} />
        </>
      );
    });
  }, [data, visible]);

  if (!visible) return <></>;
  return <>{cameraMarkers}</>;
}
